<template>
  <div>
    <v-overlay :z-index="zIndex" :opacity="0.3" v-model="overlay">
      <v-progress-circular
        style="transform: translate(250%,100%);"
        :size="300"
        :width="20"
        color="white"
        indeterminate
        >Loading...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
export default {
  data: () => ({
    overlay: true,
    zIndex: 0,
  }),
};
</script>

<style scoped>
.close {
  position: absolute;
  left: 600px;
  top: -150px;
}
.center {
  position: absolute;
  top: 20px;
  left: 23px;
}
@-webkit-keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.blink {
  text-decoration: blink;
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
}
</style>
